import React, {useContext} from 'react';
import {useNewReport} from "./hooks/useNewReport";

export const NewReportContext = React.createContext({});

export const NewReportProvider = ({children}) => {
  const state = useNewReport();

  return (
    <NewReportContext.Provider value={state}>
      {children({...state})}
    </NewReportContext.Provider>
  );
}

export const useNewReportState = () => {
  return useContext(NewReportContext);
}

export default NewReportContext;
